export class Wall {
    id: number;
    conferenceId: number;
    wallType: string;
    referenceObjectId: number;
}